module.exports = __webpack_public_path__ + "static/media/fridge-icon.186edf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fridge-icon.png
// module id = 354
// module chunks = 0